<template>
  <div class="container">
  	<div class="button">
      <i class="icon far fa-comment" @click="openModal" aria-hidden="true"></i>
  	</div>
    <CommentModal
      v-if="showCommentModal"
      :post="post"
      :model="model"
      @cancel="showCommentModal=false"
    />
    <ModalRequireLogin
      v-if="showRequiredLoginModal"
      @cancel="cancelHandler"
    />
  </div>
</template>

<script setup lang="ts">
import { Post } from '~/types/Post';
import { Model } from '~/types/Model';
import _NuxtApp from "~/types/NuxtApp";

const { $auth } = <_NuxtApp>useNuxtApp();

const { post, model } = defineProps<{
  post: Post;
  model: Model;
}>();

const showRequiredLoginModal = ref(false);
const showCommentModal = ref(false);

function cancelHandler() {
  showRequiredLoginModal.value = false;
}

function openModal() {
  if (!$auth.check()) {
    showRequiredLoginModal.value = true;
    return;
  }

  showCommentModal.value = true;
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.container {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  margin-block: unset;
}

.button {
  position: relative;
  text-align: center;
  /*background: #cccccc;*/
  cursor: pointer;
  font-weight: bold;
}

.icon {
  position: relative;
  font-size: 27px;
  vertical-align: bottom;

  top: 0px;
  // Image
  width: 28px;
  height: 28px;
  color: #858585;
  // background-size: cover;
  // background-repeat: no-repeat;
  // background-position: center;
  // background-image: url("/img/btn/heart.png");
}


// @media (hover: hover) {
//   .icon:hover {
//     background-image: url("/img/btn/heart-red.png") !important;
//   }
// }

// .icon.active {
//   background-image: url("/img/btn/heart-red.png");
// }
</style>
